export const cookieStorageOptions = {
  // Cookie legati all'host corrente, utilizzabili anche su localhost via HTTP.
  local: { secure: false },
  tunnel: { domain: 'noobi.app' },
  development: { domain: 'noobi.app' },
  sandbox: { domain: 'wakanda.local' },
  staging: { domain: 'staging.heyjob.it' },
  production: { domain: 'heyjob.it' },
};
